import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventQueryVariables = Types.Exact<{
  input: Types.GetEventInput;
}>;

export type GetEventQuery = {
  __typename?: 'Query';
  getEvent: {
    __typename?: 'GetEventResponse';
    category: string;
    classification: string;
    createdAt: string;
    endDate: string;
    eventCode: string;
    eventIncidentPhotographer?: string | null;
    expectedParticipantsNumber?: number | null;
    weatherConditions?: Array<string> | null;
    hazards?: string | null;
    isCommunicationSystemInPlace: boolean;
    isEmergencyAccessBriefingPrepared: boolean;
    isFireSafetyRequired: boolean;
    isInsuranceCoverageUnderstood: boolean;
    isMedicalEquipmentRequired: boolean;
    isPermitsObtained: boolean;
    isSafetyEquipmentRequired: boolean;
    isSanctioningBodyPermitObtained: boolean;
    leadMedicalRole?: string | null;
    marshalsNumber: number;
    isMedicalPersonnelOnSite?: boolean | null;
    name: string;
    otherSafetyMeasures?: string | null;
    participantSkillLevel?: Array<string> | null;
    participantType?: Array<string> | null;
    timezone: string;
    riskAssessmentCompletedDate?: string | null;
    riskAssessmentCompletedPersonName?: string | null;
    riskManagementCapability?: string | null;
    spectatorNumber?: number | null;
    startDate: string;
    updatedAt: string;
    uuid: string;
    venue: string;
    venueType?: string | null;
    permitNumber?: string | null;
    riskAssessmentCompletedPerson?: {
      __typename?: 'GetEventResponsePerson';
      email: string;
      firstName: string;
      lastName: string;
      uuid: string;
    } | null;
    status: {
      __typename?: 'GetEventResponseEventStatus';
      name: string;
      uuid: string;
    };
  };
};

export const GetEventDocument = gql`
  query GetEvent($input: GetEventInput!) {
    getEvent(input: $input) {
      category
      classification
      createdAt
      endDate
      eventCode
      eventIncidentPhotographer
      expectedParticipantsNumber
      weatherConditions
      hazards
      isCommunicationSystemInPlace
      isEmergencyAccessBriefingPrepared
      isFireSafetyRequired
      isInsuranceCoverageUnderstood
      isMedicalEquipmentRequired
      isPermitsObtained
      isSafetyEquipmentRequired
      isSanctioningBodyPermitObtained
      leadMedicalRole
      marshalsNumber
      isMedicalPersonnelOnSite
      name
      otherSafetyMeasures
      participantSkillLevel
      participantType
      timezone
      riskAssessmentCompletedDate
      riskAssessmentCompletedPersonName
      riskAssessmentCompletedPerson {
        email
        firstName
        lastName
        uuid
      }
      riskManagementCapability
      spectatorNumber
      startDate
      status {
        name
        uuid
      }
      updatedAt
      uuid
      venue
      venueType
      permitNumber
      riskAssessmentCompletedPerson {
        email
        firstName
        lastName
        uuid
      }
    }
  }
`;
export function useGetEventQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables> &
    ({ variables: GetEventQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export function useGetEventLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetEventQuery,
    GetEventQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export function useGetEventSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventQuery, GetEventQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventQuery, GetEventQueryVariables>(
    GetEventDocument,
    options,
  );
}
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<
  typeof useGetEventLazyQuery
>;
export type GetEventSuspenseQueryHookResult = ReturnType<
  typeof useGetEventSuspenseQuery
>;
export type GetEventQueryResult = Apollo.QueryResult<
  GetEventQuery,
  GetEventQueryVariables
>;
export function refetchGetEventQuery(variables: GetEventQueryVariables) {
  return { query: GetEventDocument, variables: variables };
}
